<template>
    <div>
        <template v-if="showPrimarySignature">
            <b-row class="seller-info-header">
                <b-col class="right-col" cols="12" md="7"> 
                    <div class="d-flex justify-content-center justify-content-sm-start">
                        <p class="mb-0"><strong>{{ primary.firstName }} {{ primary.lastName }}</strong></p>
                    </div>
                    <div class="d-flex justify-content-center justify-content-sm-start">
                        <p class="mb-0"><strong>{{ property.streetAddress }}</strong></p>
                    </div>
                    <div class="d-flex justify-content-center justify-content-sm-start">
                        <p class="address-line"><strong>{{ property.city }}, {{ property.state.slug.toUpperCase() }} {{ property.zip }}</strong></p>
                    </div>
                    
                </b-col>
                <b-col cols="12" md="5" class="d-flex justify-content-center justify-content-sm-end mb-3 align-items-center">
                    <button @click="showEditInfoModal" class="gold-button">
                        Edit Information
                    </button>
                </b-col>
            </b-row>
            <hr />
            <b-row>
                <b-col>
                    <p><strong>{{ primary.firstName }} {{ primary.lastName }}</strong>, you are about to digitally sign the documents of your disclosure.</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <p>Please be sure you’ve carefully reviewed each document in this disclosure. If you make any changes after signing, all parties will need to sign the revised documents.</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <p>If you have a second seller, they will be sent the documents to be sign after you have applied your signature</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <p>Once you have added your signature you will be able to download your forms.</p>                    
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12" sm="8">
                    <b-form-group>
                        <label
                            class="name-label"
                            for="legal-name"
                        >
                            To sign, type your full legal name
                        </label>

                        <b-form-input
                            class="legal-name-input"
                            id="legal-name"
                            v-model="primarySellerProp.legalName"
                            @input="onInputChange($event, 'legalName')"
                        ></b-form-input>

                        <b-form-invalid-feedback :state="primarySellerProp.legalNameValidationState">
                            {{ legalNameInvalidFeedback }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>

                <b-col cols="12" sm="4">
                    <b-form-group>
                        <label
                            class="sig-date-label"
                            for="signature-date"
                        >
                            Date
                        </label>
                        
                        <b-input-group class="date-choice">
                            <flat-pickr
                                id="signature-date"
                                ref="primaryDate"
                                v-model="primarySellerProp.signatureDate"
                                :config="signatureDateConfig"
                                class="form-control date-choice-inner"
                                placeholder="Select a date"
                                @input="onInputChange($event,'signatureDate')"
                            />
                            <b-input-group-append class="icon">
                                <span class="input-group-text-coherent" title="Toggle" data-toggle
                                    @click="()=>{openDatePicker('primaryDate')}">
                                    <i class="far fa-calendar-day font-size-3"></i>
                                </span>
                            </b-input-group-append>
                        </b-input-group>
                        <b-form-invalid-feedback :state="primarySellerProp.signatureDateValidationState">
                                {{ signatureDateInvalidFeedback }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row class="pt-5">
                <b-col cols="12" sm="9">
                    <div class="font-dancing-script font-size-2 border-bottom border-gray-500 mb-1">
                        <div ref="signature">
                            {{ primarySellerProp.legalName || '&nbsp;' }}
                        </div>
                    </div>

                    <div>
                        <p class="signature">
                            Signature
                        </p>
                        
                    </div>
                </b-col>

                <b-col cols="12" sm="3">
                    <div class="font-dancing-script font-size-2 border-bottom border-gray-500 mb-1">
                        {{ nameInitials || '&nbsp;' }}
                    </div>

                    <div>
                        <p class="signature">Initials</p>
                    </div>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <div class="text-right">
                        <b-button
                            v-if="hasSecondarySeller"
                            class="seller-btn"
                            pill
                            size="sm"
                            @click="onInputChange(!showSecondarySignature, 'showSecondarySignature')"
                        >
                            Secondary Seller
                        </b-button>
                    </div>
                </b-col>
            </b-row>                        
        </template>

        <template v-if="showSecondarySignature">
                <b-row >
                    <b-col>
                        <p>{{ secondaryFullName }}, you are about to digitally sign the documents of your disclosure.</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <p>Please be sure you’ve carefully reviewed each document in this disclosure. If you make any changes after signing, all parties will need to sign the revised documents.</p>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <p>Once you have added your signature you will be able to download your forms.</p>                    
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" sm="8">
                        <b-form-group>
                            <label
                                for="secondary-legal-name"
                            >
                                To sign, type your full legal name
                            </label>

                            <b-form-input
                                id="secondary-legal-name"
                                v-model="secondarySeller.secondaryLegalName"
                                @input="onInputChange($event, 'secondaryLegalName')"
                            ></b-form-input>

                            <b-form-invalid-feedback :state="secondarySeller.secondaryLegalNameValidationState">
                                {{ legalNameInvalidFeedback }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="4">
                        <b-form-group>
                            <label
                                for="secondary-signature-date"
                            >
                                Date
                            </label>

                            <b-input-group>
                                <flat-pickr
                                    id="secondary-signature-date"
                                    ref="secondarySignature"
                                    v-model="secondarySeller.secondarySignatureDate"
                                    :config="signatureDateConfig"
                                    class="form-control"
                                    placeholder="Select date"
                                    @input="onInputChange($event, 'secondarySignatureDate')"
                                />
                                <b-input-group-append>
                                    <span class="input-group-text-coherent" title="Toggle" data-toggle
                                        @click="()=>{openDatePicker('secondarySignature')}">
                                        <i class="far fa-calendar-day font-size-3"></i>
                                    </span>
                                </b-input-group-append>
                            </b-input-group>
                            <b-form-invalid-feedback :state="secondarySeller.secondarySignatureDateValidationState">
                                {{ signatureDateInvalidFeedback }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="pt-5">
                    <b-col cols="12" sm="9">
                        <div class="font-dancing-script font-size-2 border-bottom border-gray-500 mb-1">
                            <div ref="signature">
                                {{ secondarySeller.secondaryLegalName || '&nbsp;' }}
                            </div>
                        </div>

                        <div>
                            <p class="signature">Signature</p>
                        </div>
                    </b-col>

                    <b-col cols="12" sm="3">
                        <div class="font-dancing-script font-size-2 border-bottom border-gray-500 mb-1">
                            {{ secondaryNameInitials || '&nbsp;' }}
                        </div>

                        <div>
                            <p class="signature">Initials</p>
                        </div>
                    </b-col>
                </b-row>
        </template>
        <b-row>
            <b-col>
                <p class="signature-footer">
                    By submitting this form, I agree that the signature as shown above will be the electronic representation
                    of my signature for all purposes when used on this document - just the same as pen-and-paper signatures.
                    Seller also acknowledges that the statements in this notice are true to the best of Seller's belief and
                    that no person, including the broker(s), has instructed or influenced Seller to provide inaccurate
                    information or to omit any material information.
                </p>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import {primarySeller, secondarySeller} from '@helpers/order';
import OrderAppResource from "@sellers-shield-home-protection/ss-core-js/src/AppResources/OrderAppResource";
import UserMixin from '@mixins/UserMixin';
import FlatPickr from 'vue-flatpickr-component';
import {get, isEmpty} from "lodash";
export default {
    name:'FormsSignatureContent',
    emits:['change'],
    mixins:[
    UserMixin
    ],
    components:{
        FlatPickr
    },
    props:{
        orderAppResource:{
            type: OrderAppResource,
            required:true
        },
        primarySellerProp:{
            type: Object,
            default() {
                return {
                    legalName: '',
                    signatureDate: null,
                    legalNameValidationState: null,
                    signatureDateValidationState: null,
                };
            }
        },
        secondarySeller:{
            type: Object,
            default:{
                secondaryLegalName: '',
                secondarySignatureDate: null,
                secondaryLegalNameValidationState: null,
                secondarySignatureDateValidationState: null,
            }
        },
        showPrimarySignature:{
            type: Boolean,
            default: true
        },
        showSecondarySignature:{
            type: Boolean,
            default: false
        }
    },
    data:()=>({
        // order: null,
        // isModalVisible: false,
        // fields: {
        //     fName: '',
        //     lName: '',
        //     email: '',
        //     propertyAddress: '',
        //     formattedStreetAddress: '',
        //     city: '',
        //     zip: '',
        // },
        signatureDateConfig: {
            clickOpens:true,
            wrap: false,
            allowInput: false,
            altFormat: 'M j, Y',
            dateFormat: 'Y-m-d',
            minDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
            disableMobile: true
        },
        legalNameInvalidFeedback: 'Please enter your full legal name.',
        signatureDateInvalidFeedback: 'Please choose a date.',
    }),
    mounted() {
        //this.initializeFields();
    },
    methods:{
        showEditInfoModal(){
            this.$bus.$emit('show-edit-modal');
        },
        onInputChange(value, prop){
            this.$emit('change', prop, value)
        },
        getNameInitials(fullName) {
            return (fullName || '').replace(/[^a-zA-Z- ]/g, "").match(/\b\w/g).join(' ');
        },     
        openDatePicker(ref){
            switch(ref){
                case "primaryDate":
                    this.$refs.primaryDate.fp.open();        
                    break;
                case "secondarySignature":
                    this.$refs.secondarySignature.fp.open();
            }    
        },
        // async setUserData(data) {
        //     this.isModalVisible = false;
        //     if (!isEmpty(data)) {
        //         if(data.firstName){
        //             this.fields.fName = data.firstName;
        //         }
        //         if(data.lastName){
        //             this.fields.lName = data.lastName;
        //         }
        //         if (data.address) {
        //             this.fields.propertyAddress = data.address;
        //         }
        //         if (data.city) {
        //             this.fields.city = data.city;
        //         }
        //         if (data.zipCode) {
        //             this.fields.zip = data.zipCode;
        //         }
        //         if(data.secondaryFirstName){
        //             this.fields.secondaryFirstName = data.secondaryFirstName;
        //         }
        //         if(data.secondaryLastName){
        //             this.fields.secondaryLastName = data.secondaryLastName;
        //         }
        //     }
        //     return false;
        // },
        // initializeFields() {
        //     const primarySellerData = primarySeller(this.orderAppResource);
        //     const property = this.orderAppResource?.property;
        //     this.fields = {
        //         fName: primarySellerData?.firstName || '',
        //         lName: primarySellerData?.lastName || '',
        //         propertyAddress: property?.streetAddress || '',
        //         city: property?.city || '',
        //         zip: property?.zip || '',
        //     };
        // },
    },
    computed:{
        hasSecondarySeller() {
            let seller = secondarySeller(this.orderAppResource);
            return !!seller.firstName && !!seller.lastName || !!seller.email && (!!seller.uuid || !!seller.firstName || !!seller.lastName);
        },
        nameInitials() {
            if (this.primarySellerProp.legalName) {
                return this.getNameInitials(this.primarySellerProp.legalName);
            }
            return '';
        },
        secondaryFullName() {
            let seller = secondarySeller(this.orderAppResource);
            return `${seller.firstName} ${seller.lastName}`
        },

        secondaryNameInitials() {
            if (this.secondarySeller.secondaryLegalName) {
                return this.getNameInitials(this.secondarySeller.secondaryLegalName);
            }
            return '';
        },
        property(){
            return get(this.orderAppResource, 'property');
        },
        secondary(){    
            return secondarySeller(this.orderAppResource);
        },
        primary(){
            return primarySeller(this.orderAppResource);
        }
    }
}
</script>
